module.exports = __webpack_public_path__ + "img/Brazil.4244f182.gif";